import styled from "styled-components";

export const Wrapper = styled.div`
    position: relative;
    width: 100%;
    & * {
        font-size: 104% !important;
    }
`

export const Error = styled.p`
  color: red;
  /* font-size: ${(props) => (props.errorFontSize ? props.errorFontSize : "10.4px !important")}; */
  font-size: 12px !important;
  bottom: -2.2rem;
  margin-left: 0.2rem;
  position: absolute;
  z-index: 9;
`;